import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider, useAuth } from "@/lib/auth-context";
import { CountryProvider } from "@/lib/country-context";
import { RequireRestaurant } from "@/components/require-restaurant";

import LandingPage from "@/pages/landing";
import SigninPage from "@/pages/signin";
import SignupPage from "@/pages/signup";
import DashboardPage from "@/pages/dashboard";

function PortalIndex() {
  const { isRestaurant, loading } = useAuth();
  if (loading) return null;
  return isRestaurant ? <DashboardPage /> : <LandingPage />;
}

function App() {
  return (
    <AuthProvider>
      <CountryProvider>
        <TooltipProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PortalIndex />} />
              <Route path="/signin" element={<SigninPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route
                path="/dashboard"
                element={<RequireRestaurant><DashboardPage /></RequireRestaurant>}
              />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </TooltipProvider>
      </CountryProvider>
    </AuthProvider>
  );
}

export default App;
